<!-- Side Structure -->
<template>
  <div
    :class="sidebarSelectedFilter.class"
    class="sidebar"
  >
    <vue-perfect-scrollbar
      :settings="settings"
      class="scroll-area"
    >
      <v-toolbar
        class="transparent scroll-area navigation"
        flat
      >
        <v-list>
          <app-logo></app-logo>
          <user-block></user-block>
          <template v-for="(category, key) in menus">
            <div
              :key="key"
            >
              <div class="sidebar-title px-3">
                <span>{{$t(key) }}</span>
              </div>
              <template
                v-for="item in category"
              >
                <template v-if="item.items != null">
                  <v-list-group
                    :key="item.title"
                    append-icon
                    no-action
                    prepend-icon="arrow_right"
                    v-model="item.active"
                  >
                    <v-list-tile slot="activator">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <i
                            :class="item.action"
                            class="mr-3 zmdi"
                          ></i>
                          <span>{{ textTruncate($t(item.title)) }}</span>
                          <template v-if="item.label == 'New'">
                            <span class="sidebar-label">{{item.label}}</span>
                          </template>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                      :to="!subItem.exact ? `/${getCurrentAppLayoutHandler() + subItem.path}` : subItem.path"
                      v-bind:key="subItem.title"
                      v-for="subItem in item.items"
                      v-if="subItem !== null"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ textTruncate($t(subItem.title)) }}
                          <template v-if="subItem.label == 'New'">
                            <span class="sidebar-label">New</span>
                          </template>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-tile
                    :key="item.path"
                    :to="!item.exact ? `/${getCurrentAppLayoutHandler() + item.path}` : item.path"
                  >
                    <v-list-tile-action>
                      <i class="zmdi zmdi-caret-right"></i>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <i
                          :class="item.action"
                          class="mr-3 zmdi"
                        ></i>
                        <span>{{ textTruncate($t(item.title)) }}</span>
                        <template v-if="item.label == 'New'">
                          <span class="sidebar-label">New</span>
                        </template>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </template>
            </div>
          </template>
        </v-list>
      </v-toolbar>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import UserBlock from './UserBlock'
import { textTruncate, getCurrentAppLayout, filterIt } from 'Helpers/helpers'
import { mapGetters } from 'vuex'
import AppLogo from 'Components/AppLogo/AppLogo'
export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      }
    }
  },
  components: {
    UserBlock,
    AppLogo
  },
  computed: {
    ...mapGetters(['sidebarSelectedFilter', 'menus'])
  },
  mounted() {
    this.$store.dispatch('setActiveMenuGroup', this.$router)
  },
  methods: {
    textTruncate(text) {
      return textTruncate(text, 18)
    },
    getCurrentAppLayoutHandler() {
      return getCurrentAppLayout(this.$router)
    },
    showMenu(category) {
      // let code = category[0].code;
      // let user = JSON.parse(localStorage.getItem('user'));
      // let permission = user.roles.permission;
      // let result = filterIt(permission, code, "code");
      // /*console.log(code);
      // console.log(user);
      // console.log(result);*/
      // return result.length > 0 ? true : false;
      return true
    },
    showMenuItem(item) {
      // let code = item.code
      // let user = JSON.parse(localStorage.getItem('user'))
      // let permission = user.roles.permission
      // let result = filterIt(permission, code, 'code')
      // console.log(code)
      // return result.length > 0 ? true : false
    }
  },
  created() {
    //console.log(this.findPermissionCode("BT"));
    //console.log(this.menus);
  }
}
</script>
